export const SignupIcon = {
  transclude: true,

  bindings: {
    color: '<',
  },

  template: `
    <div class="signup-icon">
      <div class="d-flex justify-content-center align-items-center rounded-circle rounded-circle--50 bg-{{$ctrl.color}}">
        <span class="h2 font-weight-normal text-white m-0" ng-transclude></span>
      </div>
    </div>`,
};



// WEBPACK FOOTER //
// ./src/components/Signup/SignupIcon.js